"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsolidatedListCell = void 0;
const react_1 = __importDefault(require("react"));
const consolidated_list_cell_styles_1 = require("./consolidated-list-cell.styles");
const table_cell_styles_1 = require("../partials/table-cell.styles");
const localization_1 = require("../../../../../localization");
const ConsolidatedListCell = ({ children, className, align = 'left', expanded, valueNumber, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    let content = null;
    if (valueNumber) {
        content = expanded ? children : (react_1.default.createElement(consolidated_list_cell_styles_1.StyledValueNumber, { noWrap: true, variant: "button" }, t({ key: 'VALUE_NUMBER', values: { number: valueNumber } })));
    }
    return (react_1.default.createElement(table_cell_styles_1.StyledCommonTextTableCell, { className: className, align: align }, content));
};
exports.ConsolidatedListCell = ConsolidatedListCell;
exports.default = exports.ConsolidatedListCell;
